<template>
  <div id="contenedor-eliminar-minuta-acuerdo">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Participante </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el participante? </span>
        <v-divider></v-divider>
        <v-row>
          <span class="font-weight-bold">
            {{participanteEliminar.nombre}}
          </span>
        </v-row>
         <v-row>
          <span> <cortar-texto
          :texto="participanteEliminar.puesto">
          </cortar-texto>
          </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="botonEliminarMinutaParticipante"
          :disabled="enviandoFormulario || $apollo.loading"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';
import mixParticipantes from './mixParticipantes';

export default {
  name: 'ContenedorEliminarMinutaParticipante',
  props: {
    participanteEliminar: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixParticipantes],
  components: {
    CustomButton,
    CortarTexto,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    botonEliminarMinutaParticipante() {
      this.mixEliminarParticipante();
    },
  },
};
</script>
